// extracted by mini-css-extract-plugin
export default {"wrapper":"challenges_wrapper__Yu4mg","challengesList":"challenges_challengesList__GzKz6"};